import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";
import { IDS } from "../../IDS";

export const getTransactionHistory = async (
  name,
  transaction_type,
  from,
  to,
  page,
  per_page
) => {
  try {
    return await getData(
      `/website/transaction/history?name=${name ||
        ""}&transaction_type=${transaction_type || ""}&from=${from ||
        ""}&to=${to || ""}&page=${page || IDS.PAGE}&per_page=${per_page ||
        IDS.PERPAGE}`
    );
  } catch (error) {
    console.log(error);
  }
};
